var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"galaxy-chart"},[_c('insightReportGalaxyChartBase',{attrs:{"dataArray":_vm.chartScales,"obj":_vm.healthData,"id":"galaxy-chart"}}),_vm._v(" "),(_vm.enableTooltip)?_c('b-tooltip',{attrs:{"target":"galaxy-chart"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tooltipText)}})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1313ff0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@microbadevs/insight-report-galaxy-chart/index.vue
// module id = ynbu
// module chunks = 1